import { axiosJSONInstance } from '@/config';
import { ProfileCompanyRequest, ProfileResponse, RegisterParams } from '@/types';

// Fetch Profile
export const fetchProfile = async (): Promise<ProfileResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/profile`);
  return response.data;
};

// Update Profile
export const updateProfile = async (data: RegisterParams): Promise<ProfileResponse> => {
  const response = await axiosJSONInstance.patch(`/merchants/profile`, { data });
  return response.data;
};

// Fetch Profile Company
export const fetchProfileCompany = async (): Promise<ProfileResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/profile/company`);
  return response.data;
};

// Update Profile Company
export const updateProfileCompany = async (
  data: ProfileCompanyRequest,
): Promise<ProfileResponse> => {
  const response = await axiosJSONInstance.patch(`/merchants/profile`, { data });
  return response.data;
};

// Fetch industries list
export interface IndustriesResponse {
  status: string;
  code: number;
  message: string;
  object: string[];
}

export const fetchIndustries = async (): Promise<IndustriesResponse> => {
  const response = await axiosJSONInstance.get('/merchants/profile/company/industries');
  return response.data;
};
